import types, {baseAsyncTypes} from 'actions/types'
import {combineReducers} from 'redux'
import {createPivotTableReducer} from 'reducers/pivotTable'
import {createDataBlockReducer} from 'helpers/reducer'
import {
  defaultAgendaActivityOptions,
  defaultAgendaActivityOptionsOrder,
} from 'helpers/activities'

export const users = (state = [], action) => {
  switch (action.type) {
    case types.DIARY_UPDATE_USERS:
    case types.DIARY_UPDATE_USERS_LIST:
      return action.users
    default:
      return state
  }
}

export const contacts = (state = [], action) => {
  switch (action.type) {
    case types.DIARY_UPDATE_CONTACTS:
    case types.DIARY_UPDATE_CONTACTS_LIST:
      return action.contacts
    default:
      return state
  }
}

export const companies = (state = [], action) => {
  switch (action.type) {
    case types.DIARY_UPDATE_COMPANIES:
    case types.DIARY_UPDATE_COMPANIES_LIST:
      return action.companies
    default:
      return state
  }
}

export const selectedDate = (state = new Date(), action) => {
  switch (action.type) {
    case types.DIARY_UPDATE_SELECTED_DATE:
      return (action.selectedDate)
    default:
      return state
  }
}

export const diaryRange = (state = 'month:0', action) => {
  switch (action.type) {
    case types.DIARY_UPDATE_DIARY_RANGE:
    case types.DIARY_UPDATE_DIARY_RANGE_LIST:
      return (action.diaryRange)
    default:
      return state
  }
}

export const references = (state = [], action) => {
  switch (action.type) {
    case types.DIARY_UPDATE_REFERENCES:
    case types.DIARY_UPDATE_REFERENCES_LIST:
      return action.references
    default:
      return state
  }
}

export const activityTypes = (state = [], action) => {
  switch (action.type) {
    case types.DIARY_UPDATE_ACTIVITY_TYPE:
    case types.DIARY_UPDATE_ACTIVITY_TYPE_LIST:
      return action.activityTypeId
    default:
      return state
  }
}

export const toggleRejectedActivities = (state = false, action) => {
  switch (action.type) {
    case types.DIARY_UPDATE_REJECTED_ACTIVITIES:
    case types.DIARY_UPDATE_REJECTED_ACTIVITIES_LIST:
      return action.toggleRejected
    default:
      return state
  }
}

export const toggleCompletedActivities = (state = false, action) => {
  switch (action.type) {
    case types.DIARY_UPDATE_COMPLETED_ACTIVITIES:
    case types.DIARY_UPDATE_COMPLETED_ACTIVITIES_LIST:
      return action.toggleCompleted
    default:
      return state
  }
}

export const moveActivity = (state = [], action) => {
  switch (action.type) {
    case types.DIARY_MOVE_ACTIVITY_ATTEMPT:
      return action.activity
    default:
      return state
  }
}

export const calendarActivityOptionsOrder = (state = null, action) => {
  switch (action.type) {
    case types.DIARY_UPDATE_CALENDAR_ACTIVITY_OPTIONS_ORDER:
      return action.options
    default:
      return state
  }
}

export const calendarActivityOptions = (state = null, action) => {
  switch (action.type) {
    case types.DIARY_UPDATE_CALENDAR_ACTIVITY_OPTIONS:
      return action.options
    default:
      return state
  }
}

export const agendaActivityOptionsOrder = (state = defaultAgendaActivityOptionsOrder, action) => {
  switch (action.type) {
    case types.DIARY_UPDATE_AGENDA_ACTIVITY_OPTIONS_ORDER:
      return action.options
    default:
      return state
  }
}

export const agendaActivityOptions = (state = defaultAgendaActivityOptions, action) => {
  switch (action.type) {
    case types.DIARY_UPDATE_AGENDA_ACTIVITY_OPTIONS:
      return action.options
    default:
      return state
  }
}

export const activityCounts = (state = null, action) => {
  switch (action.type) {
    case types.DIARY_LOAD_ACTIVITY_COUNT_SUCCESS:
      return action.data
    default:
      return state
  }
}

export const isListActive = (state = null, action) => {
  switch (action.type) {
    case types.DIARY_LIST_ACTIVE:
      return true
    case types.DIARY_LIST_INACTIVE:
      return false
    default:
      return state
  }
}

export const isCalendarActive = (state = null, action) => {
  switch (action.type) {
    case types.DIARY_CALENDAR_ACTIVE:
      return true
    case types.DIARY_CALENDAR_INACTIVE:
      return false
    default:
      return state
  }
}

export const activityStatuses = (state = [], action) => {
  switch (action.type) {
    case types.DIARY_UPDATE_ACTIVITY_STATUSES:
    case types.DIARY_UPDATE_ACTIVITY_STATUSES_LIST:
      return action.statuses
    default:
      return state
  }
}

export const diaryContextActivitiesPivotTable = 'diaryContext.activities.pivotTable'

export default combineReducers({
  pivotTable: createPivotTableReducer({key: diaryContextActivitiesPivotTable, defaultSortColumn: 'startDate'}),
  calendar: createDataBlockReducer(baseAsyncTypes.DIARY_LOAD_ACTIVITIES)(null),
  users,
  contacts,
  companies,
  references,
  activityTypes,
  selectedDate,
  diaryRange,
  toggleRejectedActivities,
  toggleCompletedActivities,
  moveActivity,
  activityCounts,
  calendarActivityOptions,
  calendarActivityOptionsOrder,
  agendaActivityOptions,
  agendaActivityOptionsOrder,
  isListActive,
  isCalendarActive,
  activityStatuses,
})
